<template>
  <div
    v-if="disabled"
    ref="editable"
    class="h-100"
    v-on="listeners"
    @keypress.enter.prevent
  />
  <div
    v-else
    ref="editable"
    contenteditable
    class="h-100"
    v-on="listeners"
    @keypress.enter.prevent
  />
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        default: '',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      listeners() {
        return { ...this.$listeners, input: this.onInput };
      },
    },
    mounted() {
      this.$refs.editable.innerText = this.value;
    },
    methods: {
      onInput(e) {
        this.$emit('input', e.target.innerText);
      },
    },
  };
</script>